const B2B_SESSION_KEY = 'karup_b2b_session';

class B2BSession extends HTMLElement {
  connectedCallback() {
    const isB2B = this.dataset.b2bCustomer === 'true';
    if (isB2B)  localStorage.setItem(B2B_SESSION_KEY, JSON.stringify(isB2B));
    else  localStorage.removeItem(B2B_SESSION_KEY);
  }
}

if (!window.customElements.get("b2b-session")) {
  window.customElements.define("b2b-session", B2BSession);
}


